import { type SimpleOption } from '../../dash-select/utils/select.types'
import { type DashTablePageSize } from './dashTable.types'

export const DASH_TABLE_PAGE_SIZE_OPTIONS: SimpleOption<DashTablePageSize>[] = [
  { label: '10', value: 10 },
  { label: '25', value: 25 },
  { label: '50', value: 50 },
]
